import { FieldType } from 'common/consts/fieldType';
import { isNullOrWhiteSpace } from 'common/helpers/string';
import { AddressIsEditable } from 'common/helpers/Address';
import { fetcher } from 'app/http';

interface Props {
  Model?: any; // Data from backend
  PageData?: any;
  handleClick: Function;
  setEditAddressResponseData: Function;
}

const Address = ({
  Model,
  PageData,
  handleClick,
  setEditAddressResponseData,
}: Props) => {
  const onSubmit = async (e: any) => {
    e.preventDefault();
    try {
      const response = await fetcher.get(Model.EditAddressPageUrl);
      if (response && response.data) {
        setEditAddressResponseData(response.data);
        handleClick(true);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="cards-items">
      <div className="Customerdetails-card">
        <div className="Grid Grid--gutterHz Grid--gutterVz">
          <div className="Grid-cell">
            <div className="Customerdetails-Headerwrapper">
              <label className="Customerdetails-label">
                {PageData?.AddressLabel}
              </label>
              {AddressIsEditable(Model.ContactDetailsConfiguration) && (
                <div className="Customerdetails-button">
                  {Model.ContactDetails.AddressIsEmpty &&
                  isNullOrWhiteSpace(Model.ContactDetails.Country) ? (
                    <button
                      onClick={onSubmit}
                      className="Button Button--ghost orange-text js-contact-edit-modal"
                    >
                      {PageData.ButtonAddText}
                    </button>
                  ) : (
                    <button
                      onClick={onSubmit}
                      className="Button Button--ghost js-contact-edit-modal"
                    >
                      {PageData.ButtonEditText}
                    </button>
                  )}
                </div>
              )}
            </div>
            <ul className="List data-hj-suppress">
              {Model?.ContactDetails.AddressIsEmpty ? (
                <>
                  <li>{Model?.PageDataBase.MissingContactDetailsText}</li>
                  {AddressIsEditable(Model.ContactDetailsConfiguration) ? (
                    <li className="Phonenumber-add">{PageData.AddNowLabel}</li>
                  ) : (
                    <li className="Phonenumber-add">
                      {PageData.MissingReadonlyLabel}
                    </li>
                  )}
                </>
              ) : (
                <>
                  {(Model?.ContactDetailsConfiguration.addressFields === null ||
                    (!isNullOrWhiteSpace(Model?.ContactDetails.AddressLine1) &&
                      Model.ContactDetailsConfiguration.addressFields
                        .addressLine1 !== null &&
                      Model.ContactDetailsConfiguration.addressFields
                        .addressLine1 !== FieldType.Unavailable)) && (
                    <li>{Model?.ContactDetails.AddressLine1}</li>
                  )}
                  {(Model.ContactDetailsConfiguration.AddressFields === null ||
                    (!isNullOrWhiteSpace(Model?.ContactDetails.AddressLine2) &&
                      Model.ContactDetailsConfiguration.addressFields
                        .addressLine2 !== null &&
                      Model.ContactDetailsConfiguration.addressFields
                        .addressLine2 !== FieldType.Unavailable)) && (
                    <li>{Model.ContactDetails.AddressLine2}</li>
                  )}
                  {(Model.ContactDetailsConfiguration.AddressFields === null ||
                    (!isNullOrWhiteSpace(Model?.ContactDetails.AddressLine3) &&
                      Model.ContactDetailsConfiguration.addressFields
                        .addressLine3 !== null &&
                      Model.ContactDetailsConfiguration.addressFields
                        .addressLine3 !== FieldType.Unavailable)) && (
                    <li>{Model?.ContactDetails.AddressLine3}</li>
                  )}
                  {(Model.ContactDetailsConfiguration.AddressFields === null ||
                    (!isNullOrWhiteSpace(Model.ContactDetails.AddressLine4) &&
                      Model.ContactDetailsConfiguration.addressFields
                        .addressLine4 !== null &&
                      Model.ContactDetailsConfiguration.addressFields
                        .addressLine4 !== FieldType.Unavailable)) && (
                    <li>{Model?.ContactDetails.AddressLine4}</li>
                  )}
                  {(Model.ContactDetailsConfiguration.AddressFields === null ||
                    (!isNullOrWhiteSpace(Model.ContactDetails.AddressLine5) &&
                      Model.ContactDetailsConfiguration.addressFields
                        .addressLine5 !== null &&
                      Model.ContactDetailsConfiguration.addressFields
                        .addressLine5 !== FieldType.Unavailable)) && (
                    <li>{Model.ContactDetails.AddressLine5}</li>
                  )}
                  {(Model.ContactDetailsConfiguration.AddressFields === null ||
                    (!isNullOrWhiteSpace(Model.ContactDetails.StreetName) &&
                      Model.ContactDetailsConfiguration.addressFields
                        .streetName !== null &&
                      Model.ContactDetailsConfiguration.addressFields
                        .streetName !== FieldType.Unavailable)) && (
                    <li>
                      {Model.ContactDetails.StreetName}
                      {(Model.ContactDetailsConfiguration.AddressFields ===
                        null ||
                        (!isNullOrWhiteSpace(
                          Model.ContactDetails.HouseNumber,
                        ) &&
                          Model.ContactDetailsConfiguration.addressFields
                            .houseNumber !== null &&
                          Model.ContactDetailsConfiguration.addressFields
                            .houseNumber !== FieldType.Unavailable)) && (
                        <>
                          {!isNullOrWhiteSpace(Model.ContactDetails.StreetName)
                            ? ' '
                            : {}}
                          {Model.ContactDetails.HouseNumber}
                        </>
                      )}

                      {(Model.ContactDetailsConfiguration.AddressFields ===
                        null ||
                        (!isNullOrWhiteSpace(Model.ContactDetails.FlatNumber) &&
                          Model.ContactDetailsConfiguration.addressFields
                            .flatNumber !== null &&
                          Model.ContactDetailsConfiguration.addressFields
                            .flatNumber !== FieldType.Unavailable)) && (
                        <>
                          {!isNullOrWhiteSpace(Model.ContactDetails.HouseNumber)
                            ? '/'
                            : ''}
                          {Model.ContactDetails.StreetName &&
                          isNullOrWhiteSpace(Model.ContactDetails.HouseNumber)
                            ? ' '
                            : ''}
                          {Model.ContactDetails.FlatNumber}
                        </>
                      )}
                    </li>
                  )}
                </>
              )}
            </ul>
            {Model.ContactDetailsConfiguration.addressFields.postalCode !==
              FieldType.Unavailable && (
              <>
                <label className="Customerdetails-label CustomerdetailsLabel--post">
                  {PageData.PostalCodeLabel}
                </label>
                <span className="u-block Text--medium data-hj-suppress">
                  {Model.ContactDetails.PostalCodeIsEmpty ? (
                    <>
                      {Model?.PageDataBase.MissingContactDetailsText}
                      {Model.ContactDetailsConfiguration.addressFields
                        .postalCode === FieldType.Editable ? (
                        <span className="Phonenumber-add">
                          {PageData.AddNowLabel}
                        </span>
                      ) : (
                        <span className="Phonenumber-add">
                          {PageData.MissingReadonlyLabel}
                        </span>
                      )}
                    </>
                  ) : (
                    <>
                      {Model?.ContactDetails.PostalCode}
                      {isNullOrWhiteSpace(Model?.ContactDetails.PostalCode) &&
                      isNullOrWhiteSpace(Model?.ContactDetails.City)
                        ? ''
                        : ' '}
                      {Model?.ContactDetails.City}
                    </>
                  )}
                </span>
              </>
            )}

            {Model.ContactDetailsConfiguration.addressFields.country !==
              FieldType.Unavailable && (
              <>
                <label className="Customerdetails-label CustomerdetailsLabel--post">
                  {PageData.CountryLabel}
                </label>
                <span className="u-block Text--medium data-hj-suppress">
                  {Model.ContactDetails.CountryIsEmpty ? (
                    <>
                      {Model?.PageDataBase.MissingContactDetailsText}
                      {Model.ContactDetailsConfiguration.addressFields
                        .country === FieldType.Editable ? (
                        <span className="Phonenumber-add">
                          {PageData.AddNowLabel}
                        </span>
                      ) : (
                        <span className="Phonenumber-add">
                          {PageData.MissingReadonlyLabel}
                        </span>
                      )}
                    </>
                  ) : (
                    <>{Model.ContactDetails.Country}</>
                  )}
                </span>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Address;
